import { render, staticRenderFns } from "./formTwitter.vue?vue&type=template&id=305a4cda&"
import script from "./formTwitter.vue?vue&type=script&lang=js&"
export * from "./formTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports